// @generated by TypeGen from LogbookApi/SettingsApi.swift - DO NOT EDIT

import type { ISettingsResponse } from "../LogbookModel/Settings"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface ISettingsUpdateRequest {
  data?: string;
}

export interface SettingsApiEndpoints {
  "PUT /api/ships/:shipId/data": {
    params: { shipId: number };
    query: {};
    request: ISettingsUpdateRequest;
    response: ISettingsResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/ships/:shipId/settings": {
    params: { shipId: number };
    query: {};
    request: ISettingsUpdateRequest;
    response: ISettingsResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const settingsApiEndpoints = {
  "PUT /api/ships/:shipId/data": { targets: ["app", "server"], permission: { ship: IShipUserLevel.primary } },
  "PUT /api/ships/:shipId/settings": { targets: ["app"], permission: { ship: IShipUserLevel.primary } },
} as const;

export class SettingsApi {
  constructor(private client: ApiClient) {}

  settings = {
    updateData: (a: ApiArgs<SettingsApiEndpoints, "PUT /api/ships/:shipId/data">) => ({
      call: (): Promise<ISettingsResponse> => {
        assertTarget(this.client, "PUT /api/ships/:shipId/data", settingsApiEndpoints["PUT /api/ships/:shipId/data"].targets);
        return this.client.call<ISettingsResponse>("PUT /api/ships/:shipId/data", a);
      },
      url: (): string => this.client.url("PUT /api/ships/:shipId/data", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.primary,
    }),
    update: (a: ApiArgs<SettingsApiEndpoints, "PUT /api/ships/:shipId/settings">) => ({
      call: (): Promise<ISettingsResponse> => {
        assertTarget(this.client, "PUT /api/ships/:shipId/settings", settingsApiEndpoints["PUT /api/ships/:shipId/settings"].targets);
        return this.client.call<ISettingsResponse>("PUT /api/ships/:shipId/settings", a);
      },
      url: (): string => this.client.url("PUT /api/ships/:shipId/settings", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.primary,
    }),
  };
}
